/*
 * Copyright (c) 2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

// This file is autogenerated by this script: packages/cp-shared-ui/scripts/populate-countries-cities-json.ts.

export const IANA_TIMEZONES_MAP = {
  'Asia/Kabul': 'UTC+04:30 (Afghanistan Time)',
  'Europe/Mariehamn': 'UTC+02:00 (Eastern European Time)',
  'Europe/Tirane': 'UTC+01:00 (Central European Time)',
  'Africa/Algiers': 'UTC+01:00 (Central European Time)',
  'Pacific/Pago_Pago': 'UTC-11:00 (Samoa Standard Time)',
  'Europe/Andorra': 'UTC+01:00 (Central European Time)',
  'Africa/Luanda': 'UTC+01:00 (West Africa Time)',
  'America/Anguilla': 'UTC-04:00 (Atlantic Standard Time)',
  'Antarctica/Palmer': 'UTC-03:00 (Chile Summer Time)',
  'Antarctica/Rothera': 'UTC-03:00 (Rothera Research Station Time)',
  'Antarctica/Troll': 'UTC±00 (Greenwich Mean Time)',
  'Antarctica/Syowa': 'UTC+03:00 (Showa Station Time)',
  'Antarctica/Mawson': 'UTC+05:00 (Mawson Station Time)',
  'Antarctica/Vostok': 'UTC+06:00 (Vostok Station Time)',
  'Antarctica/Davis': 'UTC+07:00 (Davis Time)',
  'Antarctica/DumontDUrville': "UTC+10:00 (Dumont d'Urville Time)",
  'Antarctica/Casey': 'UTC+11:00 (Australian Western Standard Time)',
  'Antarctica/McMurdo': 'UTC+13:00 (New Zealand Daylight Time)',
  'America/Antigua': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Argentina/Buenos_Aires': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Catamarca': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Cordoba': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Jujuy': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/La_Rioja': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Mendoza': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Rio_Gallegos': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Salta': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/San_Juan': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/San_Luis': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Tucuman': 'UTC-03:00 (Argentina Time)',
  'America/Argentina/Ushuaia': 'UTC-03:00 (Argentina Time)',
  'Asia/Yerevan': 'UTC+04:00 (Armenia Time)',
  'America/Aruba': 'UTC-04:00 (Atlantic Standard Time)',
  'Australia/Perth': 'UTC+08:00 (Australian Western Standard Time)',
  'Australia/Eucla': 'UTC+08:45 (Australian Central Western Standard Time (Unofficial))',
  'Australia/Darwin': 'UTC+09:30 (Australian Central Standard Time)',
  'Australia/Brisbane': 'UTC+10:00 (Australian Eastern Standard Time)',
  'Australia/Lindeman': 'UTC+10:00 (Australian Eastern Standard Time)',
  'Australia/Adelaide': 'UTC+10:30 (Australian Central Daylight Saving Time)',
  'Australia/Broken_Hill': 'UTC+10:30 (Australian Central Daylight Saving Time)',
  'Antarctica/Macquarie': 'UTC+11:00 (Macquarie Island Station Time)',
  'Australia/Currie': 'UTC+11:00 (Australian Eastern Daylight Saving Time)',
  'Australia/Hobart': 'UTC+11:00 (Australian Eastern Daylight Saving Time)',
  'Australia/Lord_Howe': 'UTC+11:00 (Lord Howe Summer Time)',
  'Australia/Melbourne': 'UTC+11:00 (Australian Eastern Daylight Saving Time)',
  'Australia/Sydney': 'UTC+11:00 (Australian Eastern Daylight Saving Time)',
  'Europe/Vienna': 'UTC+01:00 (Central European Time)',
  'Asia/Baku': 'UTC+04:00 (Azerbaijan Time)',
  'Asia/Bahrain': 'UTC+03:00 (Arabia Standard Time)',
  'Asia/Dhaka': 'UTC+06:00 (Bangladesh Standard Time)',
  'America/Barbados': 'UTC-04:00 (Atlantic Standard Time)',
  'Europe/Minsk': 'UTC+03:00 (Moscow Time)',
  'Europe/Brussels': 'UTC+01:00 (Central European Time)',
  'America/Belize': 'UTC-06:00 (Central Standard Time (North America))',
  'Africa/Porto-Novo': 'UTC+01:00 (West Africa Time)',
  'Atlantic/Bermuda': 'UTC-04:00 (Atlantic Standard Time)',
  'Asia/Thimphu': 'UTC+06:00 (Bhutan Time)',
  'America/La_Paz': 'UTC-04:00 (Bolivia Time)',
  'America/Curacao': 'UTC-04:00 (Atlantic Standard Time)',
  'Europe/Sarajevo': 'UTC+01:00 (Central European Time)',
  'Africa/Gaborone': 'UTC+02:00 (Central Africa Time)',
  'Europe/Oslo': 'UTC+01:00 (Central European Time)',
  'America/Eirunepe': 'UTC-05:00 (Acre Time)',
  'America/Rio_Branco': 'UTC-05:00 (Acre Time)',
  'America/Boa_Vista': 'UTC-04:00 (Amazon Time (Brazil)[3)',
  'America/Campo_Grande': 'UTC-04:00 (Amazon Time (Brazil)[3)',
  'America/Cuiaba': 'UTC-04:00 (Brasilia Time)',
  'America/Manaus': 'UTC-04:00 (Amazon Time (Brazil))',
  'America/Porto_Velho': 'UTC-04:00 (Amazon Time (Brazil)[3)',
  'America/Araguaina': 'UTC-03:00 (Brasília Time)',
  'America/Bahia': 'UTC-03:00 (Brasília Time)',
  'America/Belem': 'UTC-03:00 (Brasília Time)',
  'America/Fortaleza': 'UTC-03:00 (Brasília Time)',
  'America/Maceio': 'UTC-03:00 (Brasília Time)',
  'America/Recife': 'UTC-03:00 (Brasília Time)',
  'America/Santarem': 'UTC-03:00 (Brasília Time)',
  'America/Sao_Paulo': 'UTC-03:00 (Brasília Time)',
  'America/Noronha': 'UTC-02:00 (Fernando de Noronha Time)',
  'Indian/Chagos': 'UTC+06:00 (Indian Ocean Time)',
  'Asia/Brunei': 'UTC+08:00 (Brunei Darussalam Time)',
  'Europe/Sofia': 'UTC+02:00 (Eastern European Time)',
  'Africa/Ouagadougou': 'UTC±00 (Greenwich Mean Time)',
  'Africa/Bujumbura': 'UTC+02:00 (Central Africa Time)',
  'Asia/Phnom_Penh': 'UTC+07:00 (Indochina Time)',
  'Africa/Douala': 'UTC+01:00 (West Africa Time)',
  'America/Vancouver': 'UTC-08:00 (Pacific Standard Time (North America)',
  'America/Cambridge_Bay': 'UTC-07:00 (Mountain Standard Time (North America))',
  'America/Creston': 'UTC-07:00 (Mountain Standard Time (North America))',
  'America/Dawson': 'UTC-07:00 (Mountain Standard Time (North America))',
  'America/Dawson_Creek': 'UTC-07:00 (Mountain Standard Time (North America))',
  'America/Edmonton': 'UTC-07:00 (Mountain Standard Time (North America))',
  'America/Fort_Nelson': 'UTC-07:00 (Mountain Standard Time (North America))',
  'America/Inuvik': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Whitehorse': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Yellowknife': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Rainy_River': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Rankin_Inlet': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Regina': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Resolute': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Swift_Current': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Winnipeg': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Atikokan': 'UTC-05:00 (Eastern Standard Time (North America))',
  'America/Iqaluit': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Nipigon': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Pangnirtung': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Thunder_Bay': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Toronto': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Blanc-Sablon': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Glace_Bay': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Goose_Bay': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Halifax': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Moncton': 'UTC-04:00 (Atlantic Standard Time)',
  'America/St_Johns': 'UTC-03:30 (Newfoundland Standard Time)',
  'Atlantic/Cape_Verde': 'UTC-01:00 (Cape Verde Time)',
  'America/Cayman': 'UTC-05:00 (Eastern Standard Time (North America)',
  'Africa/Bangui': 'UTC+01:00 (West Africa Time)',
  'Africa/Ndjamena': 'UTC+01:00 (West Africa Time)',
  'Pacific/Easter': 'UTC-05:00 (Easter Island Summer Time)',
  'America/Punta_Arenas': 'UTC-03:00 (Chile Summer Time)',
  'America/Santiago': 'UTC-03:00 (Chile Summer Time)',
  'Asia/Urumqi': 'UTC+06:00 (China Standard Time)',
  'Asia/Shanghai': 'UTC+08:00 (China Standard Time)',
  'Indian/Christmas': 'UTC+07:00 (Christmas Island Time)',
  'Indian/Cocos': 'UTC+06:30 (Cocos Islands Time)',
  'America/Bogota': 'UTC-05:00 (Colombia Time)',
  'Indian/Comoro': 'UTC+03:00 (East Africa Time)',
  'Africa/Brazzaville': 'UTC+01:00 (West Africa Time)',
  'Pacific/Rarotonga': 'UTC-10:00 (Cook Island Time)',
  'America/Costa_Rica': 'UTC-06:00 (Central Standard Time (North America)',
  'Europe/Zagreb': 'UTC+01:00 (Central European Time)',
  'America/Havana': 'UTC-05:00 (Cuba Standard Time)',
  'Asia/Famagusta': 'UTC+02:00 (Eastern European Time)',
  'Asia/Nicosia': 'UTC+02:00 (Eastern European Time)',
  'Europe/Prague': 'UTC+01:00 (Central European Time)',
  'Africa/Kinshasa': 'UTC+01:00 (West Africa Time)',
  'Africa/Lubumbashi': 'UTC+02:00 (Central Africa Time)',
  'Europe/Copenhagen': 'UTC+01:00 (Central European Time)',
  'Africa/Djibouti': 'UTC+03:00 (East Africa Time)',
  'America/Dominica': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Santo_Domingo': 'UTC-04:00 (Atlantic Standard Time)',
  'Pacific/Galapagos': 'UTC-06:00 (Galápagos Time)',
  'America/Guayaquil': 'UTC-05:00 (Ecuador Time)',
  'Africa/Cairo': 'UTC+02:00 (Eastern European Time)',
  'America/El_Salvador': 'UTC-06:00 (Central Standard Time (North America)',
  'Africa/Malabo': 'UTC+01:00 (West Africa Time)',
  'Africa/Asmara': 'UTC+03:00 (East Africa Time)',
  'Europe/Tallinn': 'UTC+02:00 (Eastern European Time)',
  'Africa/Mbabane': 'UTC+02:00 (South African Standard Time)',
  'Africa/Addis_Ababa': 'UTC+03:00 (East Africa Time)',
  'Atlantic/Stanley': 'UTC-03:00 (Falkland Islands Summer Time)',
  'Atlantic/Faroe': 'UTC±00 (Western European Time)',
  'Pacific/Fiji': 'UTC+12:00 (Fiji Time)',
  'Europe/Helsinki': 'UTC+02:00 (Eastern European Time)',
  'Europe/Paris': 'UTC+01:00 (Central European Time)',
  'America/Cayenne': 'UTC-03:00 (French Guiana Time)',
  'Pacific/Tahiti': 'UTC-10:00 (Tahiti Time)',
  'Pacific/Marquesas': 'UTC-09:30 (Marquesas Islands Time)',
  'Pacific/Gambier': 'UTC-09:00 (Gambier Islands Time)',
  'Indian/Kerguelen': 'UTC+05:00 (French Southern and Antarctic Time)',
  'Africa/Libreville': 'UTC+01:00 (West Africa Time)',
  'Asia/Tbilisi': 'UTC+04:00 (Georgia Standard Time)',
  'Europe/Berlin': 'UTC+01:00 (Central European Time)',
  'Europe/Busingen': 'UTC+01:00 (Central European Time)',
  'Africa/Accra': 'UTC±00 (Greenwich Mean Time)',
  'Europe/Gibraltar': 'UTC+01:00 (Central European Time)',
  'Europe/Athens': 'UTC+02:00 (Eastern European Time)',
  'America/Thule': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Nuuk': 'UTC-03:00 (West Greenland Time)',
  'America/Scoresbysund': 'UTC-01:00 (Eastern Greenland Time)',
  'America/Danmarkshavn': 'UTC±00 (Greenwich Mean Time)',
  'America/Grenada': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Guadeloupe': 'UTC-04:00 (Atlantic Standard Time)',
  'Pacific/Guam': 'UTC+10:00 (Chamorro Standard Time)',
  'America/Guatemala': 'UTC-06:00 (Central Standard Time (North America)',
  'Europe/Guernsey': 'UTC±00 (Greenwich Mean Time)',
  'Africa/Conakry': 'UTC±00 (Greenwich Mean Time)',
  'Africa/Bissau': 'UTC±00 (Greenwich Mean Time)',
  'America/Guyana': 'UTC-04:00 (Guyana Time)',
  'America/Port-au-Prince': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Tegucigalpa': 'UTC-06:00 (Central Standard Time (North America)',
  'Asia/Hong_Kong': 'UTC+08:00 (Hong Kong Time)',
  'Europe/Budapest': 'UTC+01:00 (Central European Time)',
  'Atlantic/Reykjavik': 'UTC±00 (Greenwich Mean Time)',
  'Asia/Kolkata': 'UTC+05:30 (Indian Standard Time)',
  'Asia/Jakarta': 'UTC+07:00 (Western Indonesian Time)',
  'Asia/Pontianak': 'UTC+07:00 (Western Indonesian Time)',
  'Asia/Makassar': 'UTC+08:00 (Central Indonesia Time)',
  'Asia/Jayapura': 'UTC+09:00 (Eastern Indonesian Time)',
  'Asia/Tehran': 'UTC+03:30 (Iran Daylight Time)',
  'Asia/Baghdad': 'UTC+03:00 (Arabia Standard Time)',
  'Europe/Dublin': 'UTC±00 (Greenwich Mean Time)',
  'Asia/Jerusalem': 'UTC+02:00 (Israel Standard Time)',
  'Europe/Rome': 'UTC+01:00 (Central European Time)',
  'Africa/Abidjan': 'UTC±00 (Greenwich Mean Time)',
  'America/Jamaica': 'UTC-05:00 (Eastern Standard Time (North America)',
  'Asia/Tokyo': 'UTC+09:00 (Japan Standard Time)',
  'Europe/Jersey': 'UTC±00 (Greenwich Mean Time)',
  'Asia/Amman': 'UTC+02:00 (Eastern European Time)',
  'Asia/Aqtau': 'UTC+05:00 (Aqtobe Time)',
  'Asia/Aqtobe': 'UTC+05:00 (Aqtobe Time)',
  'Asia/Atyrau': 'UTC+05:00 (Moscow Daylight Time+1)',
  'Asia/Oral': 'UTC+05:00 (Oral Time)',
  'Asia/Qyzylorda': 'UTC+05:00 (Qyzylorda Summer Time)',
  'Asia/Almaty': 'UTC+06:00 (Alma-Ata Time[1)',
  'Asia/Qostanay': 'UTC+06:00 (Qyzylorda Summer Time)',
  'Africa/Nairobi': 'UTC+03:00 (East Africa Time)',
  'Pacific/Tarawa': 'UTC+12:00 (Gilbert Island Time)',
  'Pacific/Enderbury': 'UTC+13:00 (Phoenix Island Time)',
  'Pacific/Kiritimati': 'UTC+14:00 (Line Islands Time)',
  'Europe/Belgrade': 'UTC+01:00 (Central European Time)',
  'Asia/Kuwait': 'UTC+03:00 (Arabia Standard Time)',
  'Asia/Bishkek': 'UTC+06:00 (Kyrgyzstan Time)',
  'Asia/Vientiane': 'UTC+07:00 (Indochina Time)',
  'Europe/Riga': 'UTC+02:00 (Eastern European Time)',
  'Asia/Beirut': 'UTC+02:00 (Eastern European Time)',
  'Africa/Maseru': 'UTC+02:00 (South African Standard Time)',
  'Africa/Monrovia': 'UTC±00 (Greenwich Mean Time)',
  'Africa/Tripoli': 'UTC+02:00 (Eastern European Time)',
  'Europe/Vaduz': 'UTC+01:00 (Central European Time)',
  'Europe/Vilnius': 'UTC+02:00 (Eastern European Time)',
  'Europe/Luxembourg': 'UTC+01:00 (Central European Time)',
  'Asia/Macau': 'UTC+08:00 (China Standard Time)',
  'Indian/Antananarivo': 'UTC+03:00 (East Africa Time)',
  'Africa/Blantyre': 'UTC+02:00 (Central Africa Time)',
  'Asia/Kuala_Lumpur': 'UTC+08:00 (Malaysia Time)',
  'Asia/Kuching': 'UTC+08:00 (Malaysia Time)',
  'Indian/Maldives': 'UTC+05:00 (Maldives Time)',
  'Africa/Bamako': 'UTC±00 (Greenwich Mean Time)',
  'Europe/Malta': 'UTC+01:00 (Central European Time)',
  'Europe/Isle_of_Man': 'UTC±00 (Greenwich Mean Time)',
  'Pacific/Kwajalein': 'UTC+12:00 (Marshall Islands Time)',
  'Pacific/Majuro': 'UTC+12:00 (Marshall Islands Time)',
  'America/Martinique': 'UTC-04:00 (Atlantic Standard Time)',
  'Africa/Nouakchott': 'UTC±00 (Greenwich Mean Time)',
  'Indian/Mauritius': 'UTC+04:00 (Mauritius Time)',
  'Indian/Mayotte': 'UTC+03:00 (East Africa Time)',
  'America/Tijuana': 'UTC-08:00 (Pacific Standard Time (North America)',
  'America/Chihuahua': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Hermosillo': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Mazatlan': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Ojinaga': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Bahia_Banderas': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Matamoros': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Merida': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Mexico_City': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Monterrey': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Cancun': 'UTC-05:00 (Eastern Standard Time (North America)',
  'Pacific/Chuuk': 'UTC+10:00 (Chuuk Time)',
  'Pacific/Kosrae': 'UTC+11:00 (Kosrae Time)',
  'Pacific/Pohnpei': 'UTC+11:00 (Pohnpei Standard Time)',
  'Europe/Chisinau': 'UTC+02:00 (Eastern European Time)',
  'Europe/Monaco': 'UTC+01:00 (Central European Time)',
  'Asia/Hovd': 'UTC+07:00 (Hovd Time)',
  'Asia/Choibalsan': 'UTC+08:00 (Choibalsan Standard Time)',
  'Asia/Ulaanbaatar': 'UTC+08:00 (Ulaanbaatar Standard Time)',
  'Europe/Podgorica': 'UTC+01:00 (Central European Time)',
  'America/Montserrat': 'UTC-04:00 (Atlantic Standard Time)',
  'Africa/Casablanca': 'UTC+01:00 (Western European Summer Time)',
  'Africa/El_Aaiun': 'UTC+01:00 (Western European Summer Time)',
  'Africa/Maputo': 'UTC+02:00 (Central Africa Time)',
  'Asia/Yangon': 'UTC+06:30 (Myanmar Standard Time)',
  'Africa/Windhoek': 'UTC+02:00 (West Africa Summer Time)',
  'Pacific/Nauru': 'UTC+12:00 (Nauru Time)',
  'Asia/Kathmandu': 'UTC+05:45 (Nepal Time)',
  'Europe/Amsterdam': 'UTC+01:00 (Central European Time)',
  'Pacific/Noumea': 'UTC+11:00 (New Caledonia Time)',
  'Pacific/Auckland': 'UTC+13:00 (New Zealand Daylight Time)',
  'Pacific/Chatham': 'UTC+13:45 (Chatham Standard Time)',
  'America/Managua': 'UTC-06:00 (Central Standard Time (North America)',
  'Africa/Niamey': 'UTC+01:00 (West Africa Time)',
  'Africa/Lagos': 'UTC+01:00 (West Africa Time)',
  'Pacific/Niue': 'UTC-11:00 (Niue Time)',
  'Pacific/Norfolk': 'UTC+12:00 (Norfolk Time)',
  'Asia/Pyongyang': 'UTC+09:00 (Korea Standard Time)',
  'Europe/Skopje': 'UTC+01:00 (Central European Time)',
  'Pacific/Saipan': 'UTC+10:00 (Chamorro Standard Time)',
  'Arctic/Longyearbyen': 'UTC+01:00 (Central European Time)',
  'Asia/Muscat': 'UTC+04:00 (Gulf Standard Time)',
  'Asia/Karachi': 'UTC+05:00 (Pakistan Standard Time)',
  'Pacific/Palau': 'UTC+09:00 (Palau Time)',
  'Asia/Gaza': 'UTC+02:00 (Eastern European Time)',
  'Asia/Hebron': 'UTC+02:00 (Eastern European Time)',
  'America/Panama': 'UTC-05:00 (Eastern Standard Time (North America)',
  'Pacific/Port_Moresby': 'UTC+10:00 (Papua New Guinea Time)',
  'Pacific/Bougainville': 'UTC+11:00 (Bougainville Standard Time[6)',
  'America/Asuncion': 'UTC-03:00 (Paraguay Summer Time)',
  'America/Lima': 'UTC-05:00 (Peru Time)',
  'Asia/Manila': 'UTC+08:00 (Philippine Time)',
  'Pacific/Pitcairn': 'UTC-08:00 (Pacific Standard Time (North America)',
  'Europe/Warsaw': 'UTC+01:00 (Central European Time)',
  'Atlantic/Azores': 'UTC-01:00 (Azores Standard Time)',
  'Atlantic/Madeira': 'UTC±00 (Western European Time)',
  'Europe/Lisbon': 'UTC±00 (Western European Time)',
  'America/Puerto_Rico': 'UTC-04:00 (Atlantic Standard Time)',
  'Asia/Qatar': 'UTC+03:00 (Arabia Standard Time)',
  'Indian/Reunion': 'UTC+04:00 (Réunion Time)',
  'Europe/Bucharest': 'UTC+02:00 (Eastern European Time)',
  'Europe/Kaliningrad': 'UTC+02:00 (Eastern European Time)',
  'Europe/Kirov': 'UTC+03:00 (Moscow Time)',
  'Europe/Moscow': 'UTC+03:00 (Moscow Time)',
  'Europe/Astrakhan': 'UTC+04:00 (Samara Time)',
  'Europe/Samara': 'UTC+04:00 (Samara Time)',
  'Europe/Saratov': 'UTC+04:00 (Moscow Daylight Time+4)',
  'Europe/Ulyanovsk': 'UTC+04:00 (Samara Time)',
  'Europe/Volgograd': 'UTC+04:00 (Moscow Standard Time)',
  'Asia/Yekaterinburg': 'UTC+05:00 (Yekaterinburg Time)',
  'Asia/Omsk': 'UTC+06:00 (Omsk Time)',
  'Asia/Barnaul': 'UTC+07:00 (Krasnoyarsk Time)',
  'Asia/Krasnoyarsk': 'UTC+07:00 (Krasnoyarsk Time)',
  'Asia/Novokuznetsk': 'UTC+07:00 (Krasnoyarsk Time)',
  'Asia/Novosibirsk': 'UTC+07:00 (Novosibirsk Time)',
  'Asia/Tomsk': 'UTC+07:00 (Moscow Daylight Time+3)',
  'Asia/Irkutsk': 'UTC+08:00 (Irkutsk Time)',
  'Asia/Chita': 'UTC+09:00 (Yakutsk Time)',
  'Asia/Khandyga': 'UTC+09:00 (Yakutsk Time)',
  'Asia/Yakutsk': 'UTC+09:00 (Yakutsk Time)',
  'Asia/Ust-Nera': 'UTC+10:00 (Vladivostok Time)',
  'Asia/Vladivostok': 'UTC+10:00 (Vladivostok Time)',
  'Asia/Magadan': 'UTC+11:00 (Magadan Time)',
  'Asia/Sakhalin': 'UTC+11:00 (Sakhalin Island Time)',
  'Asia/Srednekolymsk': 'UTC+11:00 (Srednekolymsk Time)',
  'Asia/Anadyr': 'UTC+12:00 (Anadyr Time[4)',
  'Asia/Kamchatka': 'UTC+12:00 (Kamchatka Time)',
  'Africa/Kigali': 'UTC+02:00 (Central Africa Time)',
  'Atlantic/St_Helena': 'UTC±00 (Greenwich Mean Time)',
  'America/St_Kitts': 'UTC-04:00 (Atlantic Standard Time)',
  'America/St_Lucia': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Miquelon': 'UTC-03:00 (Pierre & Miquelon Daylight Time)',
  'America/St_Vincent': 'UTC-04:00 (Atlantic Standard Time)',
  'America/St_Barthelemy': 'UTC-04:00 (Atlantic Standard Time)',
  'America/Marigot': 'UTC-04:00 (Atlantic Standard Time)',
  'Pacific/Apia': 'UTC+14:00 (West Samoa Time)',
  'Europe/San_Marino': 'UTC+01:00 (Central European Time)',
  'Africa/Sao_Tome': 'UTC±00 (Greenwich Mean Time)',
  'Asia/Riyadh': 'UTC+03:00 (Arabia Standard Time)',
  'Africa/Dakar': 'UTC±00 (Greenwich Mean Time)',
  'Indian/Mahe': 'UTC+04:00 (Seychelles Time)',
  'Africa/Freetown': 'UTC±00 (Greenwich Mean Time)',
  'Asia/Singapore': 'UTC+08:00 (Singapore Time)',
  'Europe/Bratislava': 'UTC+01:00 (Central European Time)',
  'Europe/Ljubljana': 'UTC+01:00 (Central European Time)',
  'Pacific/Guadalcanal': 'UTC+11:00 (Solomon Islands Time)',
  'Africa/Mogadishu': 'UTC+03:00 (East Africa Time)',
  'Africa/Johannesburg': 'UTC+02:00 (South African Standard Time)',
  'Atlantic/South_Georgia': 'UTC-02:00 (South Georgia and the South Sandwich Islands Time)',
  'Asia/Seoul': 'UTC+09:00 (Korea Standard Time)',
  'Africa/Juba': 'UTC+03:00 (East Africa Time)',
  'Atlantic/Canary': 'UTC±00 (Western European Time)',
  'Africa/Ceuta': 'UTC+01:00 (Central European Time)',
  'Europe/Madrid': 'UTC+01:00 (Central European Time)',
  'Asia/Colombo': 'UTC+05:30 (Indian Standard Time)',
  'Africa/Khartoum': 'UTC+02:00 (Eastern African Time)',
  'America/Paramaribo': 'UTC-03:00 (Suriname Time)',
  'Europe/Stockholm': 'UTC+01:00 (Central European Time)',
  'Europe/Zurich': 'UTC+01:00 (Central European Time)',
  'Asia/Damascus': 'UTC+02:00 (Eastern European Time)',
  'Asia/Taipei': 'UTC+08:00 (China Standard Time)',
  'Asia/Dushanbe': 'UTC+05:00 (Tajikistan Time)',
  'Africa/Dar_es_Salaam': 'UTC+03:00 (East Africa Time)',
  'Asia/Bangkok': 'UTC+07:00 (Indochina Time)',
  'America/Nassau': 'UTC-05:00 (Eastern Standard Time (North America))',
  'Africa/Banjul': 'UTC±00 (Greenwich Mean Time)',
  'Asia/Dili': 'UTC+09:00 (Timor Leste Time)',
  'Africa/Lome': 'UTC±00 (Greenwich Mean Time)',
  'Pacific/Fakaofo': 'UTC+13:00 (Tokelau Time)',
  'Pacific/Tongatapu': 'UTC+13:00 (Tonga Time)',
  'America/Port_of_Spain': 'UTC-04:00 (Atlantic Standard Time)',
  'Africa/Tunis': 'UTC+01:00 (Central European Time)',
  'Europe/Istanbul': 'UTC+03:00 (Eastern European Time)',
  'Asia/Ashgabat': 'UTC+05:00 (Turkmenistan Time)',
  'America/Grand_Turk': 'UTC-05:00 (Eastern Standard Time (North America)',
  'Pacific/Funafuti': 'UTC+12:00 (Tuvalu Time)',
  'Africa/Kampala': 'UTC+03:00 (East Africa Time)',
  'Europe/Kiev': 'UTC+02:00 (Eastern European Time)',
  'Europe/Uzhgorod': 'UTC+02:00 (Eastern European Time)',
  'Europe/Zaporozhye': 'UTC+02:00 (Eastern European Time)',
  'Europe/Simferopol': 'UTC+03:00 (Moscow Time)',
  'Asia/Dubai': 'UTC+04:00 (Gulf Standard Time)',
  'Europe/London': 'UTC±00 (Greenwich Mean Time)',
  'America/Adak': 'UTC-10:00 (Hawaii–Aleutian Standard Time)',
  'Pacific/Honolulu': 'UTC-10:00 (Hawaii–Aleutian Standard Time)',
  'America/Anchorage': 'UTC-09:00 (Alaska Standard Time)',
  'America/Juneau': 'UTC-09:00 (Alaska Standard Time)',
  'America/Metlakatla': 'UTC-09:00 (Alaska Standard Time)',
  'America/Nome': 'UTC-09:00 (Alaska Standard Time)',
  'America/Sitka': 'UTC-09:00 (Alaska Standard Time)',
  'America/Yakutat': 'UTC-09:00 (Alaska Standard Time)',
  'America/Los_Angeles': 'UTC-08:00 (Pacific Standard Time (North America)',
  'America/Boise': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Denver': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Phoenix': 'UTC-07:00 (Mountain Standard Time (North America)',
  'America/Chicago': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Indiana/Knox': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Indiana/Tell_City': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Menominee': 'UTC-06:00 (Central Standard Time (North America)',
  'America/North_Dakota/Beulah': 'UTC-06:00 (Central Standard Time (North America)',
  'America/North_Dakota/Center': 'UTC-06:00 (Central Standard Time (North America)',
  'America/North_Dakota/New_Salem': 'UTC-06:00 (Central Standard Time (North America)',
  'America/Detroit': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Indiana/Indianapolis': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Indiana/Marengo': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Indiana/Petersburg': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Indiana/Vevay': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Indiana/Vincennes': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Indiana/Winamac': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Kentucky/Louisville': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/Kentucky/Monticello': 'UTC-05:00 (Eastern Standard Time (North America)',
  'America/New_York': 'UTC-05:00 (Eastern Standard Time (North America)',
  'Pacific/Midway': 'UTC-11:00 (Samoa Standard Time)',
  'Pacific/Wake': 'UTC+12:00 (Wake Island Time)',
  'America/Montevideo': 'UTC-03:00 (Uruguay Standard Time)',
  'Asia/Samarkand': 'UTC+05:00 (Uzbekistan Time)',
  'Asia/Tashkent': 'UTC+05:00 (Uzbekistan Time)',
  'Pacific/Efate': 'UTC+11:00 (Vanuatu Time)',
  'Europe/Vatican': 'UTC+01:00 (Central European Time)',
  'America/Caracas': 'UTC-04:00 (Venezuelan Standard Time)',
  'Asia/Ho_Chi_Minh': 'UTC+07:00 (Indochina Time)',
  'America/Tortola': 'UTC-04:00 (Atlantic Standard Time)',
  'America/St_Thomas': 'UTC-04:00 (Atlantic Standard Time)',
  'Pacific/Wallis': 'UTC+12:00 (Wallis & Futuna Time)',
  'Asia/Aden': 'UTC+03:00 (Arabia Standard Time)',
  'Africa/Lusaka': 'UTC+02:00 (Central Africa Time)',
  'Africa/Harare': 'UTC+02:00 (Central Africa Time)'
}
